import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "snore-setting"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "custom-title"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "vip-tag"
}, "VIP", -1);

var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_radio = _resolveComponent("van-radio");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_radio_group = _resolveComponent("van-radio-group");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_radio_group, {
    modelValue: _ctx.type,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.type = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_cell, {
        title: _ctx.$t('message.snore.localStorage'),
        clickable: "",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.changeType('free');
        })
      }, {
        "right-icon": _withCtx(function () {
          return [_createVNode(_component_van_radio, {
            name: "free"
          }, {
            icon: _withCtx(function (props) {
              return [_createElementVNode("img", {
                class: "img-icon",
                src: props.checked ? $data.activeIcon : $data.inactiveIcon
              }, null, 8, _hoisted_2)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["title"]), _createVNode(_component_van_cell, {
        title: _ctx.$t('message.snore.cloudStorage'),
        clickable: "",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.changeType('vip');
        })
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('message.snore.cloudStorage')), 1), _hoisted_4];
        }),
        "right-icon": _withCtx(function () {
          return [_createVNode(_component_van_radio, {
            name: "vip"
          }, {
            icon: _withCtx(function (props) {
              return [_createElementVNode("img", {
                class: "img-icon",
                src: props.checked ? $data.activeIcon : $data.inactiveIcon
              }, null, 8, _hoisted_5)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["title"])];
    }),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.snore.storageWayTips')), 1)]);
}